// @ts-nocheck
/**
 * WebSocket presence + ops (G.7–G.8, H.4) для доски.
 */

  var PEER_COLORS = [
    "#6246ea",
    "#ef4565",
    "#2cb67d",
    "#f97316",
    "#0ea5e9",
    "#a855f7",
    "#eab308",
    "#14b8a6",
  ];

  /** Сколько ждать подписки, прежде чем бросить сокет и попробовать заново. */
  var CONNECT_TIMEOUT_MS = 8000;

  function hashColor(peerId) {
    var h = 0;
    for (var i = 0; i < peerId.length; i++) {
      h = (h * 31 + peerId.charCodeAt(i)) | 0;
    }
    return PEER_COLORS[Math.abs(h) % PEER_COLORS.length];
  }

  function shortPeerLabel(peerId) {
    return peerId.slice(0, 4);
  }

  function cursorStageCoord(v) {
    if (!Number.isFinite(v)) return 0;
    return Math.round(v * 10) / 10;
  }

  function WbBoardPresence(options) {
    this.boardId = options.boardId;
    this.shareToken = options.shareToken || null;
    this.guestEditKey = options.guestEditKey || null;
    this.adminSpectate = Boolean(options.adminSpectate);
    this.silent = Boolean(options.silent || options.adminSpectate);
    this.mapClientToStage =
      typeof options.mapClientToStage === "function" ? options.mapClientToStage : null;
    this.canEditOps = Boolean(options.canEditOps);
    this.canvas = options.canvas;
    this.onStatus =
      typeof options.onStatus === "function" ? options.onStatus : function () {};
    this.onPeersChange =
      typeof options.onPeersChange === "function" ? options.onPeersChange : function () {};
    this.onRosterChange =
      typeof options.onRosterChange === "function" ? options.onRosterChange : function () {};
    this.getViewport =
      typeof options.getViewport === "function" ? options.getViewport : null;
    this.onPeerPresence =
      typeof options.onPeerPresence === "function" ? options.onPeerPresence : function () {};
    this.roster = Object.create(null);
    this.ws = null;
    this.myPeerId = null;
    this.peers = Object.create(null);
    this.reconnectAttempt = 0;
    /** Доску перехватила другая вкладка: ждём возвращения, а не ломимся назад. */
    this.replaced = false;
    this.maxReconnectDelayMs = 30000;
    this.reconnectTimer = null;
    this.closedByUser = false;
    this.lastSentAt = 0;
    this.presenceMinIntervalMs = options.presenceMinIntervalMs || 16;
    this.peerStaleMs = options.peerStaleMs || 8000;
    this.presenceHeartbeatMs = options.presenceHeartbeatMs || 2500;
    this.staleCheckTimer = null;
    this.heartbeatTimer = null;
    this.flushTimer = null;
    this.pendingCursor = null;
    this.pendingLaser = null;
    this._lastCursor = null;
    this._lastClientX = null;
    this._lastClientY = null;
    this.laserAltActive = false;
    this.selectionDragging = false;
    this.localLaserEl = null;
    this.localLaserTrail = [];
    this.peerLaserTrails = Object.create(null);
    this.laserTrailCanvas = null;
    this.laserTrailCtx = null;
    this.laserTrailRaf = 0;
    /** Длина «хвоста кометы» (мс). */
    this.laserTrailLifeMs = options.laserTrailLifeMs || 820;
    /** Мин. шаг между точками хвоста (stage coords). */
    this.laserTrailMinDistStage = options.laserTrailMinDistStage || 2.5;
    this.cursorSmoothRaf = 0;
    this.cursorSmoothLastTs = 0;
    /** Плавность хвоста курсора (мс): больше = мягче движение. */
    this.cursorSmoothTauMs = options.cursorSmoothTauMs || 240;
    /** На сколько мс «заглядываем вперёд» между сетевыми пакетами. */
    this.cursorExtrapolateMaxMs = options.cursorExtrapolateMaxMs || 160;
    this.pendingOpsAcks = Object.create(null);
    this.opsAckTimeoutMs = options.opsAckTimeoutMs || 15000;
    this.onRemoteOps =
      typeof options.onRemoteOps === "function" ? options.onRemoteOps : null;
    this.onRemoteOpsEarly =
      typeof options.onRemoteOpsEarly === "function" ? options.onRemoteOpsEarly : null;
    this.onRemoteOpsRevert =
      typeof options.onRemoteOpsRevert === "function" ? options.onRemoteOpsRevert : null;
    this.onSignal =
      typeof options.onSignal === "function" ? options.onSignal : null;
    this.onPeerJoined =
      typeof options.onPeerJoined === "function" ? options.onPeerJoined : null;
    this.onSubscribed =
      typeof options.onSubscribed === "function" ? options.onSubscribed : null;
    this._onMouseMove = this.onMouseMove.bind(this);
    this._onKeyDown = this.onKeyDown.bind(this);
    this._onKeyUp = this.onKeyUp.bind(this);
    this._onWindowBlur = this.onWindowBlur.bind(this);
    this._onLiveViewport = this.onLiveViewport.bind(this);
    this._onSelectionDrag = this.onSelectionDrag.bind(this);
    this._onTabVisible = this.onTabVisible.bind(this);
  }

  WbBoardPresence.prototype.wsUrl = function () {
    var proto = location.protocol === "https:" ? "wss:" : "ws:";
    return proto + "//" + location.host + "/api/ws";
  };

  WbBoardPresence.prototype.connect = function () {
    var self = this;
    if (this.closedByUser) return;

    this.onStatus("connecting");

    try {
      this.ws = new WebSocket(this.wsUrl());
    } catch (_err) {
      this.scheduleReconnect();
      return;
    }
    this.connectStartedAt = Date.now();

    // Срок на подключение. Телефон, вернувшийся из фона, поднимает сеть не
    // сразу, и новый сокет мог «висеть» в подключении минуту и больше — всё
    // это время доска показывала «offline», помогала только перезагрузка.
    // Не дождались подписки — бросаем этот сокет и пробуем заново.
    var pending = this.ws;
    if (this.connectTimeoutTimer) clearTimeout(this.connectTimeoutTimer);
    this.connectTimeoutTimer = setTimeout(function () {
      self.connectTimeoutTimer = null;
      if (self.ws !== pending || self.myPeerId) return;
      try {
        pending.close();
      } catch (_err) {
        /* уже закрыт — onclose сам запланирует повтор */
      }
    }, CONNECT_TIMEOUT_MS);

    this.ws.onopen = function () {
      // Паузу между попытками сбрасывает УСПЕШНАЯ ПОДПИСКА, а не открытие
      // сокета. Иначе сокет, который открылся и тут же умер, крутился бы
      // раз в секунду вечно: пауза каждый раз обнулялась.
      self.onStatus("connected");
      var msg = { type: "subscribe", boardId: self.boardId };
      if (self.adminSpectate) {
        msg.adminSpectate = true;
      } else {
        if (self.shareToken) {
          msg.shareToken = self.shareToken;
        }
        if (self.guestEditKey) {
          msg.guestEditKey = self.guestEditKey;
        }
      }
      self.ws.send(JSON.stringify(msg));
    };

    this.ws.onmessage = function (ev) {
      self.handleMessage(String(ev.data));
    };

    this.ws.onclose = function () {
      self.myPeerId = null;
      self.onStatus("disconnected");
      if (!self.closedByUser) {
        self.scheduleReconnect();
      }
    };

    this.ws.onerror = function () {
      /* onclose выполнит реконнект */
    };
  };

  /**
   * Вкладка снова перед глазами — значит, работают в ней, и доска нужна здесь.
   * Та, что осталась позади, молчит до своего возвращения: так вкладки
   * сменяют друг друга по очереди, а не дерутся.
   */
  WbBoardPresence.prototype.onTabVisible = function () {
    if (typeof document !== "undefined" && document.visibilityState !== "visible") return;
    if (this.replaced) {
      this.replaced = false;
      this.closedByUser = false;
      this.connect();
      return;
    }
    // Вернулись из фона (телефон, Telegram), а связи нет: не ждём очередной
    // паузы между попытками — пока телефон спал, она выросла до 30 секунд.
    this.reconnectIfStuck();
  };

  /**
   * Переподключиться сразу, если связь потеряна или подключение зависло.
   * Живое и только что начатое подключение не трогаем: «focus» на компьютере
   * приходит часто, и рвать нормальную подписку незачем.
   */
  WbBoardPresence.prototype.reconnectIfStuck = function () {
    if (this.closedByUser || this.replaced) return;
    var ws = this.ws;
    var subscribed = Boolean(ws && ws.readyState === 1 && this.myPeerId);
    if (subscribed) return;
    var startedAgo = Date.now() - (this.connectStartedAt || 0);
    var connecting = Boolean(ws && (ws.readyState === 0 || ws.readyState === 1));
    if (connecting && startedAgo < 4000) return;
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    this.reconnectAttempt = 0;
    if (ws) {
      ws.onopen = null;
      ws.onmessage = null;
      ws.onclose = null;
      ws.onerror = null;
      try {
        ws.close();
      } catch (_err) {
        /* уже закрыт */
      }
    }
    this.ws = null;
    this.myPeerId = null;
    this.connect();
  };

  WbBoardPresence.prototype.scheduleReconnect = function () {
    var self = this;
    if (this.reconnectTimer || this.closedByUser) return;

    var base = Math.min(
      1000 * Math.pow(2, this.reconnectAttempt),
      this.maxReconnectDelayMs
    );
    var jitter = Math.floor(Math.random() * 400);
    var delay = base + jitter;
    this.reconnectAttempt += 1;

    this.onStatus("reconnecting", delay);

    this.reconnectTimer = setTimeout(function () {
      self.reconnectTimer = null;
      self.connect();
    }, delay);
  };

  WbBoardPresence.prototype.handleMessage = function (raw) {
    var msg;
    try {
      msg = JSON.parse(raw);
    } catch (_err) {
      return;
    }

    if (msg.type === "evicted") {
      // Доску открыли в другом месте под тем же человеком, и сервер закрыл
      // это подключение. Переподключаться наперегонки нельзя: две вкладки
      // выбивали друг друга раз в секунду без конца. Оживём, когда человек
      // вернётся именно в эту вкладку (onTabVisible).
      this.replaced = true;
      this.closedByUser = true;
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      this.onStatus("replaced");
      return;
    }

    if (msg.type === "subscribed") {
      this.reconnectAttempt = 0;
      this.myPeerId = msg.peerId;
      if (this.connectTimeoutTimer) {
        clearTimeout(this.connectTimeoutTimer);
        this.connectTimeoutTimer = null;
      }
      if (msg.capabilities && typeof msg.capabilities.edit_ops === "boolean") {
        this.canEditOps = msg.capabilities.edit_ops;
      }
      if (typeof msg.silent === "boolean") {
        this.silent = msg.silent;
      }
      this.applyRosterFromSubscribe(msg);
      this.onStatus("subscribed", msg);
      this.startStaleCheck();
      this.startHeartbeat();
      if (!this.silent && this.pendingCursor) {
        this.sendPresenceFlush(true);
      }
      if (this.onSubscribed) this.onSubscribed();
      return;
    }

    if (msg.type === "peer_joined" && msg.peerId && msg.peerId !== this.myPeerId) {
      this.roster[msg.peerId] = {
        displayLabel: msg.displayLabel || shortPeerLabel(msg.peerId),
        isSelf: false,
      };
      this.emitRosterChange();
      if (this.onPeerJoined) this.onPeerJoined(msg.peerId);
      return;
    }

    if (msg.type === "peer_left" && msg.peerId) {
      delete this.roster[msg.peerId];
      this.removePeer(msg.peerId);
      this.emitRosterChange();
      return;
    }

    if (msg.type === "presence" && msg.peerId && msg.peerId !== this.myPeerId) {
      this.updatePeerPresence(msg.peerId, msg);
      return;
    }

    if (msg.type === "ops_ack") {
      this.resolveOpsAck(msg);
      return;
    }

    if (msg.type === "ops_early" && msg.peerId !== this.myPeerId) {
      if (this.onRemoteOpsEarly) {
        this.onRemoteOpsEarly(msg);
      }
      return;
    }

    if (msg.type === "ops_revert" && msg.peerId !== this.myPeerId) {
      if (this.onRemoteOpsRevert) {
        this.onRemoteOpsRevert(msg);
      }
      return;
    }

    if (msg.type === "ops_applied" && msg.peerId !== this.myPeerId) {
      if (this.onRemoteOps) {
        this.onRemoteOps(msg);
      }
      return;
    }

    if (msg.type === "signal" && typeof msg.kind === "string") {
      if (this.onSignal) {
        this.onSignal({
          peerId: msg.peerId || null,
          displayLabel: msg.displayLabel || null,
          kind: msg.kind,
          payload: msg.payload && typeof msg.payload === "object" ? msg.payload : {},
          ts: typeof msg.ts === "number" ? msg.ts : Date.now(),
          isSelf: Boolean(msg.peerId && msg.peerId === this.myPeerId),
        });
      }
      return;
    }

    if (msg.type === "error") {
      this.onStatus("error", msg.error);
      if (msg.error === "forbidden") {
        this.closedByUser = true;
        if (this.ws) this.ws.close();
      }
    }
  };

  WbBoardPresence.prototype.applyRosterFromSubscribe = function (msg) {
    this.roster = Object.create(null);
    if (this.myPeerId) {
      this.roster[this.myPeerId] = {
        displayLabel: msg.displayLabel || shortPeerLabel(this.myPeerId),
        isSelf: true,
      };
    }
    var peers = msg.peers;
    if (Array.isArray(peers)) {
      for (var i = 0; i < peers.length; i++) {
        var p = peers[i];
        if (!p || !p.peerId || p.peerId === this.myPeerId) continue;
        this.roster[p.peerId] = {
          displayLabel: p.displayLabel || shortPeerLabel(p.peerId),
          isSelf: false,
        };
      }
    }
    this.emitRosterChange();
  };

  WbBoardPresence.prototype.emitRosterChange = function () {
    var list = [];
    for (var id in this.roster) {
      if (!Object.prototype.hasOwnProperty.call(this.roster, id)) continue;
      var e = this.roster[id];
      list.push({
        peerId: id,
        displayLabel: e.displayLabel,
        isSelf: !!e.isSelf,
      });
    }
    list.sort(function (a, b) {
      if (a.isSelf) return -1;
      if (b.isSelf) return 1;
      return String(a.displayLabel).localeCompare(String(b.displayLabel), "ru");
    });
    this.onRosterChange(list);
    this.onPeersChange(list.length);
  };

  WbBoardPresence.prototype.emitPeerCount = function () {
    var n = 0;
    for (var k in this.peers) {
      if (Object.prototype.hasOwnProperty.call(this.peers, k)) n++;
    }
    var total = this.myPeerId ? n + 1 : n;
    this.onPeersChange(total);
  };

  WbBoardPresence.prototype.ensurePeerEl = function (peerId) {
    var peer = this.peers[peerId];
    if (peer) return peer;

    var color = hashColor(peerId);
    var root = document.createElement("div");
    root.className = "wb-peer-cursor is-quiet";
    root.setAttribute("data-peer-id", peerId);

    var pointer = document.createElement("span");
    pointer.className = "wb-peer-cursor__pointer";
    pointer.style.color = color;

    var label = document.createElement("span");
    label.className = "wb-peer-cursor__label";
    label.textContent = shortPeerLabel(peerId);
    label.style.background = color;

    root.appendChild(pointer);
    root.appendChild(label);
    this.canvas.appendChild(root);

    var laser = document.createElement("div");
    laser.className = "wb-peer-laser";
    laser.hidden = true;
    laser.style.setProperty("--wb-laser-color", color);
    this.canvas.appendChild(laser);

    peer = {
      el: root,
      laserEl: laser,
      lastSeen: Date.now(),
      viewport: null,
      lastCursor: null,
      lastLaser: null,
      displayStage: null,
      displayLaserStage: null,
      displayScreen: null,
      displayLaser: null,
      cursorVel: null,
      cursorSampleAt: 0,
      labelQuietTimer: null,
    };
    this.peers[peerId] = peer;
    return peer;
  };

  /** Имя у курсора вспыхивает при движении, потом остаётся только стрелка. */
  WbBoardPresence.prototype.pulsePeerLabel = function (peer) {
    if (!peer || !peer.el) return;
    peer.el.classList.remove("is-quiet");
    peer.el.classList.add("is-speaking");
    if (peer.labelQuietTimer) {
      clearTimeout(peer.labelQuietTimer);
    }
    peer.labelQuietTimer = setTimeout(function () {
      peer.labelQuietTimer = null;
      if (!peer.el) return;
      peer.el.classList.add("is-quiet");
      peer.el.classList.remove("is-speaking");
    }, 1600);
  };

  WbBoardPresence.prototype.stageToScreen = function (stageX, stageY) {
    if (this.getViewport) {
      var vp = this.getViewport();
      var scale = vp.scale > 0 ? vp.scale : 1;
      return {
        x: vp.panX + stageX * scale,
        y: vp.panY + stageY * scale,
      };
    }
    return { x: stageX, y: stageY };
  };

  /** Экранные coords внутри viewport — 1:1 с clientX/Y мыши. */
  WbBoardPresence.prototype.clientToCanvasLocal = function (clientX, clientY) {
    if (!this.canvas) return { x: 0, y: 0 };
    var rect = this.canvas.getBoundingClientRect();
    return { x: clientX - rect.left, y: clientY - rect.top };
  };

  WbBoardPresence.prototype.localLaserScreenPos = function () {
    if (this._lastClientX == null || this._lastClientY == null) return null;
    return this.clientToCanvasLocal(this._lastClientX, this._lastClientY);
  };

  WbBoardPresence.prototype.setLaserActiveDom = function (active) {
    if (!this.canvas) return;
    this.canvas.classList.toggle("is-laser-active", active);
    var stage = this.canvas.querySelector(".wb-board-stage");
    if (stage) stage.classList.toggle("is-laser-active", active);
  };

  WbBoardPresence.prototype.colorWithAlpha = function (hex, alpha) {
    var a = Math.max(0, Math.min(1, alpha));
    if (!hex || hex.charAt(0) !== "#") {
      return "rgba(239, 69, 101, " + a + ")";
    }
    var h = hex.slice(1);
    if (h.length === 3) {
      h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    }
    var r = parseInt(h.slice(0, 2), 16);
    var g = parseInt(h.slice(2, 4), 16);
    var b = parseInt(h.slice(4, 6), 16);
    if (!Number.isFinite(r) || !Number.isFinite(g) || !Number.isFinite(b)) {
      return "rgba(239, 69, 101, " + a + ")";
    }
    return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
  };

  WbBoardPresence.prototype.ensureLaserTrailCanvas = function () {
    if (this.laserTrailCanvas) return this.laserTrailCanvas;
    if (!this.canvas) return null;
    var canvas = document.createElement("canvas");
    canvas.className = "wb-laser-trail-canvas";
    canvas.setAttribute("aria-hidden", "true");
    this.canvas.appendChild(canvas);
    this.laserTrailCanvas = canvas;
    this.laserTrailCtx = canvas.getContext("2d");
    this.syncLaserTrailCanvasSize();
    return canvas;
  };

  WbBoardPresence.prototype.syncLaserTrailCanvasSize = function () {
    var canvas = this.laserTrailCanvas;
    if (!canvas || !this.canvas) return;
    var w = this.canvas.clientWidth;
    var h = this.canvas.clientHeight;
    if (w < 1 || h < 1) return;
    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w;
      canvas.height = h;
    }
  };

  WbBoardPresence.prototype.pruneLaserTrail = function (trail, now, lifeMs) {
    if (!trail || !trail.length) return;
    var cutoff = now - lifeMs;
    while (trail.length && trail[0].t < cutoff) {
      trail.shift();
    }
  };

  WbBoardPresence.prototype.pushLaserTrailPoint = function (trail, stageX, stageY) {
    if (!trail) return;
    var minDist = this.laserTrailMinDistStage > 0 ? this.laserTrailMinDistStage : 2.5;
    if (trail.length) {
      var last = trail[trail.length - 1];
      var dx = stageX - last.x;
      var dy = stageY - last.y;
      if (Math.hypot(dx, dy) < minDist) return;
    }
    trail.push({ x: stageX, y: stageY, t: Date.now() });
    while (trail.length > 140) {
      trail.shift();
    }
    this.ensureLaserTrailCanvas();
    this.ensureLaserTrailLoop();
  };

  WbBoardPresence.prototype.hasVisibleLaserTrails = function () {
    if (this.localLaserTrail && this.localLaserTrail.length > 1) return true;
    for (var peerId in this.peerLaserTrails) {
      if (!Object.prototype.hasOwnProperty.call(this.peerLaserTrails, peerId)) continue;
      var trail = this.peerLaserTrails[peerId];
      if (trail && trail.length > 1) return true;
    }
    return false;
  };

  WbBoardPresence.prototype.hasActivePeerLasers = function () {
    for (var peerId in this.peers) {
      if (!Object.prototype.hasOwnProperty.call(this.peers, peerId)) continue;
      if (this.peers[peerId] && this.peers[peerId].lastLaser) return true;
    }
    return false;
  };

  WbBoardPresence.prototype.drawLaserTrail = function (
    ctx,
    points,
    colorHex,
    now,
    lifeMs,
    headScreen
  ) {
    if (!points || points.length < 1) return;

    var screenPts = [];
    for (var i = 0; i < points.length; i++) {
      var p = points[i];
      var age = now - p.t;
      if (age >= lifeMs) continue;
      var alpha = 1 - age / lifeMs;
      var sc = this.stageToScreen(p.x, p.y);
      screenPts.push({ x: sc.x, y: sc.y, alpha: alpha });
    }
    if (headScreen) {
      screenPts.push({ x: headScreen.x, y: headScreen.y, alpha: 1 });
    }
    if (screenPts.length < 2) return;

    ctx.save();
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    for (var j = 1; j < screenPts.length; j++) {
      var a = screenPts[j - 1];
      var b = screenPts[j];
      var segAlpha = Math.max(0.04, (a.alpha + b.alpha) * 0.5);
      var width = 0.8 + 8.5 * b.alpha;
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.lineWidth = width;
      ctx.strokeStyle = this.colorWithAlpha(colorHex, segAlpha * 0.9);
      if (b.alpha > 0.35) {
        ctx.shadowBlur = 10 * b.alpha;
        ctx.shadowColor = this.colorWithAlpha(colorHex, segAlpha * 0.45);
      } else {
        ctx.shadowBlur = 0;
      }
      ctx.stroke();
    }

    var head = screenPts[screenPts.length - 1];
    if (!headScreen) {
      ctx.shadowBlur = 14 * head.alpha;
      ctx.shadowColor = this.colorWithAlpha(colorHex, head.alpha * 0.55);
      ctx.beginPath();
      ctx.arc(head.x, head.y, 2.2 + 3.8 * head.alpha, 0, Math.PI * 2);
      ctx.fillStyle = this.colorWithAlpha(colorHex, head.alpha * 0.95);
      ctx.fill();
    }
    ctx.restore();
  };

  WbBoardPresence.prototype.renderLaserTrails = function () {
    var canvas = this.laserTrailCanvas;
    var ctx = this.laserTrailCtx;
    if (!canvas || !ctx) return;

    this.syncLaserTrailCanvasSize();
    var now = Date.now();
    var life = this.laserTrailLifeMs > 0 ? this.laserTrailLifeMs : 820;

    this.pruneLaserTrail(this.localLaserTrail, now, life);
    for (var peerId in this.peerLaserTrails) {
      if (!Object.prototype.hasOwnProperty.call(this.peerLaserTrails, peerId)) continue;
      this.pruneLaserTrail(this.peerLaserTrails[peerId], now, life);
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    var localHead = this.laserAltActive ? this.localLaserScreenPos() : null;
    if (this.localLaserTrail && (this.localLaserTrail.length > 0 || localHead)) {
      this.drawLaserTrail(ctx, this.localLaserTrail, "#ef4565", now, life, localHead);
    }

    for (var pid in this.peerLaserTrails) {
      if (!Object.prototype.hasOwnProperty.call(this.peerLaserTrails, pid)) continue;
      var trail = this.peerLaserTrails[pid];
      var peer = this.peers[pid];
      var peerHead = peer && peer.displayLaser ? peer.displayLaser : null;
      if (trail && (trail.length > 0 || peerHead)) {
        this.drawLaserTrail(ctx, trail, hashColor(pid), now, life, peerHead);
      }
    }
  };

  WbBoardPresence.prototype.ensureLaserTrailLoop = function () {
    var self = this;
    if (self.laserTrailRaf) return;
    function tick() {
      self.laserTrailRaf = requestAnimationFrame(tick);
      if (self.laserAltActive) {
        self.layoutLocalLaser();
      }
      self.renderLaserTrails();
      if (
        !self.laserAltActive &&
        !self.hasActivePeerLasers() &&
        !self.hasVisibleLaserTrails()
      ) {
        self.stopLaserTrailLoop();
      }
    }
    self.laserTrailRaf = requestAnimationFrame(tick);
  };

  WbBoardPresence.prototype.stopLaserTrailLoop = function () {
    if (this.laserTrailRaf) {
      cancelAnimationFrame(this.laserTrailRaf);
      this.laserTrailRaf = 0;
    }
    if (this.laserTrailCtx && this.laserTrailCanvas) {
      this.laserTrailCtx.clearRect(
        0,
        0,
        this.laserTrailCanvas.width,
        this.laserTrailCanvas.height
      );
    }
  };

  WbBoardPresence.prototype.pushPeerLaserTrailPoint = function (peerId, stageX, stageY) {
    if (!this.peerLaserTrails[peerId]) {
      this.peerLaserTrails[peerId] = [];
    }
    this.pushLaserTrailPoint(this.peerLaserTrails[peerId], stageX, stageY);
  };

  WbBoardPresence.prototype.applyPeerCursorDom = function (peer) {
    if (!peer || !peer.displayScreen) return;
    var laserOn = Boolean(peer.lastLaser && peer.displayLaser);
    peer.el.style.display = laserOn ? "none" : "";
    if (!laserOn) {
      peer.el.style.transform =
        "translate3d(" +
        peer.displayScreen.x +
        "px, " +
        peer.displayScreen.y +
        "px, 0)";
    }
    if (peer.displayLaser && peer.laserEl) {
      peer.laserEl.hidden = false;
      peer.laserEl.style.transform =
        "translate3d(" +
        peer.displayLaser.x +
        "px, " +
        peer.displayLaser.y +
        "px, 0)";
    } else if (peer.laserEl) {
      peer.laserEl.hidden = true;
    }
  };

  WbBoardPresence.prototype.hasActivePeerCursors = function () {
    for (var peerId in this.peers) {
      if (!Object.prototype.hasOwnProperty.call(this.peers, peerId)) continue;
      if (this.peers[peerId] && this.peers[peerId].lastCursor) return true;
    }
    return false;
  };

  WbBoardPresence.prototype.initPeerCursorDisplay = function (peer) {
    if (!peer || !peer.lastCursor) return;
    if (!peer.displayStage) {
      peer.displayStage = { x: peer.lastCursor.x, y: peer.lastCursor.y };
    }
    if (peer.lastLaser && !peer.displayLaserStage) {
      peer.displayLaserStage = { x: peer.lastLaser.x, y: peer.lastLaser.y };
    }
  };

  WbBoardPresence.prototype.renderPeerCursorScreen = function (peer) {
    if (!peer) return;
    this.initPeerCursorDisplay(peer);
    if (peer.displayStage) {
      peer.displayScreen = this.stageToScreen(peer.displayStage.x, peer.displayStage.y);
    }
    if (peer.displayLaserStage) {
      peer.displayLaser = this.stageToScreen(
        peer.displayLaserStage.x,
        peer.displayLaserStage.y
      );
    } else {
      peer.displayLaser = null;
    }
    this.applyPeerCursorDom(peer);
  };

  WbBoardPresence.prototype.extrapolatePeerTargetStage = function (peer) {
    if (!peer || !peer.lastCursor) return null;
    var target = { x: peer.lastCursor.x, y: peer.lastCursor.y };
    if (peer.cursorVel && peer.cursorSampleAt) {
      var age = Math.min(this.cursorExtrapolateMaxMs, Date.now() - peer.cursorSampleAt);
      if (age > 0) {
        target.x += peer.cursorVel.vx * age;
        target.y += peer.cursorVel.vy * age;
      }
    }
    return target;
  };

  WbBoardPresence.prototype.ensureCursorSmoothLoop = function () {
    var self = this;
    if (self.cursorSmoothRaf) return;
    self.cursorSmoothLastTs = 0;
    function tick(ts) {
      self.cursorSmoothRaf = requestAnimationFrame(tick);
      var dt = self.cursorSmoothLastTs ? Math.min(48, ts - self.cursorSmoothLastTs) : 16;
      self.cursorSmoothLastTs = ts;
      self.tickPeerCursorSmooth(dt);
      if (!self.hasActivePeerCursors()) {
        self.stopCursorSmoothLoop();
      }
    }
    self.cursorSmoothRaf = requestAnimationFrame(tick);
  };

  WbBoardPresence.prototype.stopCursorSmoothLoop = function () {
    if (this.cursorSmoothRaf) {
      cancelAnimationFrame(this.cursorSmoothRaf);
      this.cursorSmoothRaf = 0;
    }
    this.cursorSmoothLastTs = 0;
  };

  WbBoardPresence.prototype.tickPeerCursorSmooth = function (dtMs) {
    var tau = this.cursorSmoothTauMs > 0 ? this.cursorSmoothTauMs : 240;
    var t = 1 - Math.exp(-dtMs / tau);

    for (var peerId in this.peers) {
      if (!Object.prototype.hasOwnProperty.call(this.peers, peerId)) continue;
      var peer = this.peers[peerId];
      if (!peer || !peer.lastCursor) continue;

      var targetStage = this.extrapolatePeerTargetStage(peer);
      if (!targetStage) continue;

      this.initPeerCursorDisplay(peer);
      var ds = peer.displayStage;
      var dx = targetStage.x - ds.x;
      var dy = targetStage.y - ds.y;
      var dist = Math.hypot(dx, dy);
      if (dist > 400) {
        ds.x = targetStage.x;
        ds.y = targetStage.y;
      } else if (dist > 0.05) {
        ds.x += dx * t;
        ds.y += dy * t;
      } else {
        ds.x = targetStage.x;
        ds.y = targetStage.y;
      }

      if (peer.lastLaser) {
        if (!peer.displayLaserStage) {
          peer.displayLaserStage = { x: peer.lastLaser.x, y: peer.lastLaser.y };
        }
        peer.displayLaserStage.x = peer.lastLaser.x;
        peer.displayLaserStage.y = peer.lastLaser.y;
      } else {
        peer.displayLaserStage = null;
      }

      this.renderPeerCursorScreen(peer);
    }
  };

  WbBoardPresence.prototype.layoutPeerCursor = function (peer) {
    this.renderPeerCursorScreen(peer);
  };

  WbBoardPresence.prototype.refreshPeerCursors = function () {
    for (var peerId in this.peers) {
      if (!Object.prototype.hasOwnProperty.call(this.peers, peerId)) continue;
      this.renderPeerCursorScreen(this.peers[peerId]);
    }
    this.layoutLocalLaser();
    if (this.hasVisibleLaserTrails() || this.laserAltActive || this.hasActivePeerLasers()) {
      this.ensureLaserTrailCanvas();
      this.ensureLaserTrailLoop();
    }
  };

  WbBoardPresence.prototype.ensureLocalLaserEl = function () {
    if (this.localLaserEl) return this.localLaserEl;
    if (!this.canvas) return null;
    var el = document.createElement("div");
    el.className = "wb-local-laser";
    el.hidden = true;
    el.setAttribute("aria-hidden", "true");
    this.canvas.appendChild(el);
    this.localLaserEl = el;
    return el;
  };

  WbBoardPresence.prototype.layoutLocalLaser = function () {
    var el = this.localLaserEl;
    if (!el) return;
    if (!this.laserAltActive || this._lastClientX == null || this._lastClientY == null) {
      el.hidden = true;
      return;
    }
    var lp = this.clientToCanvasLocal(this._lastClientX, this._lastClientY);
    el.hidden = false;
    el.style.transform = "translate3d(" + lp.x + "px, " + lp.y + "px, 0)";
  };

  WbBoardPresence.prototype.setLaserActive = function (active) {
    var next = Boolean(active);
    if (this.laserAltActive === next) {
      if (next) this.layoutLocalLaser();
      return;
    }
    this.laserAltActive = next;
    this.setLaserActiveDom(next);
    if (next) {
      this.remapCursorFromLastClient();
      this.ensureLocalLaserEl();
      this.ensureLaserTrailCanvas();
      if (this._lastCursor) {
        this.pendingLaser = {
          x: this._lastCursor.x,
          y: this._lastCursor.y,
        };
        this.pushLaserTrailPoint(this.localLaserTrail, this._lastCursor.x, this._lastCursor.y);
      }
      this.layoutLocalLaser();
      this.ensureLaserTrailLoop();
      this.sendPresenceFlush(true);
    } else {
      this.pendingLaser = null;
      this.layoutLocalLaser();
      this.sendPresenceFlush(true);
    }
  };

  WbBoardPresence.prototype.updatePeerPresence = function (peerId, msg) {
    var peer = this.ensurePeerEl(peerId);
    peer.lastSeen = Date.now();

    if (msg.displayLabel && typeof msg.displayLabel === "string") {
      var labelEl = peer.el.querySelector(".wb-peer-cursor__label");
      if (labelEl) labelEl.textContent = msg.displayLabel;
    }

    var cursor = msg.cursor;
    // laser приходит в том же сообщении (см. wsProtocol), но переменную забыли
    // объявить — updatePeerPresence падал с ReferenceError на КАЖДОМ сообщении
    // о присутствии, и участники доски отображались неверно.
    var laser = msg.laser;
    if (cursor && typeof cursor.x === "number" && typeof cursor.y === "number") {
      var nx = cursorStageCoord(cursor.x);
      var ny = cursorStageCoord(cursor.y);
      var moved =
        !peer.lastCursor ||
        peer.lastCursor.x !== nx ||
        peer.lastCursor.y !== ny;
      var now = Date.now();
      if (moved && peer.lastCursor) {
        var dt = peer.cursorSampleAt ? Math.max(8, now - peer.cursorSampleAt) : 16;
        var vx = (nx - peer.lastCursor.x) / dt;
        var vy = (ny - peer.lastCursor.y) / dt;
        var speed = Math.hypot(vx, vy);
        if (speed > 2.5) {
          vx = (vx / speed) * 2.5;
          vy = (vy / speed) * 2.5;
        }
        peer.cursorVel = { vx: vx, vy: vy };
      } else if (!peer.lastCursor) {
        peer.cursorVel = null;
      }
      peer.lastCursor = { x: nx, y: ny };
      peer.cursorSampleAt = now;
      if (moved) this.pulsePeerLabel(peer);
      this.initPeerCursorDisplay(peer);
      this.ensureCursorSmoothLoop();
    }

    if (laser && typeof laser.x === "number" && typeof laser.y === "number") {
      var lx = cursorStageCoord(laser.x);
      var ly = cursorStageCoord(laser.y);
      var laserMoved =
        !peer.lastLaser || peer.lastLaser.x !== lx || peer.lastLaser.y !== ly;
      peer.lastLaser = { x: lx, y: ly };
      peer.displayLaserStage = { x: lx, y: ly };
      if (laserMoved) {
        this.pushPeerLaserTrailPoint(peerId, lx, ly);
        this.pulsePeerLabel(peer);
      }
      this.ensureCursorSmoothLoop();
    } else {
      peer.lastLaser = null;
      peer.displayLaserStage = null;
      peer.displayLaser = null;
    }

    if (msg.viewport && typeof msg.viewport.panX === "number") {
      peer.viewport = msg.viewport;
    }

    this.onPeerPresence(peerId, {
      viewport: peer.viewport || null,
      cursor: peer.lastCursor || null,
      laser: laser || null,
      displayLabel: msg.displayLabel || null,
    });
  };

  WbBoardPresence.prototype.updatePeer = function (peerId, cursor, displayLabel) {
    this.updatePeerPresence(peerId, { cursor: cursor, displayLabel: displayLabel });
  };

  WbBoardPresence.prototype.removePeer = function (peerId) {
    var peer = this.peers[peerId];
    if (peer) {
      if (peer.labelQuietTimer) {
        clearTimeout(peer.labelQuietTimer);
        peer.labelQuietTimer = null;
      }
      if (peer.el.parentNode) {
        peer.el.parentNode.removeChild(peer.el);
      }
      if (peer.laserEl && peer.laserEl.parentNode) {
        peer.laserEl.parentNode.removeChild(peer.laserEl);
      }
      delete this.peerLaserTrails[peerId];
      delete this.peers[peerId];
    }
    if (this.roster[peerId]) {
      delete this.roster[peerId];
      this.emitRosterChange();
    }
  };

  /** Курсор пропал по таймауту — не выкидываем человека из верхней панели. */
  WbBoardPresence.prototype.hideStalePeerCursor = function (peerId) {
    var peer = this.peers[peerId];
    if (!peer) return;
    if (peer.labelQuietTimer) {
      clearTimeout(peer.labelQuietTimer);
      peer.labelQuietTimer = null;
    }
    if (peer.el && peer.el.parentNode) {
      peer.el.parentNode.removeChild(peer.el);
    }
    if (peer.laserEl && peer.laserEl.parentNode) {
      peer.laserEl.parentNode.removeChild(peer.laserEl);
    }
    delete this.peerLaserTrails[peerId];
    delete this.peers[peerId];
  };

  WbBoardPresence.prototype.startStaleCheck = function () {
    var self = this;
    if (this.staleCheckTimer) return;
    this.staleCheckTimer = setInterval(function () {
      var now = Date.now();
      for (var peerId in self.peers) {
        if (Object.prototype.hasOwnProperty.call(self.peers, peerId)) {
          if (now - self.peers[peerId].lastSeen > self.peerStaleMs) {
            self.hideStalePeerCursor(peerId);
          }
        }
      }
    }, 2000);
  };

  /** Heartbeat: без mousemove (pan тачпадом / другая вкладка) presence не молчит. */
  WbBoardPresence.prototype.startHeartbeat = function () {
    var self = this;
    if (this.heartbeatTimer) return;
    this.heartbeatTimer = setInterval(function () {
      if (!self.ws || self.ws.readyState !== 1 || !self.myPeerId) return;
      self.remapCursorFromLastClient();
      self.sendPresenceFlush(true);
    }, this.presenceHeartbeatMs);
  };

  WbBoardPresence.prototype.sendPresenceFlush = function (force) {
    if (this.silent) return;
    if (!this.ws || this.ws.readyState !== 1 || !this.myPeerId) {
      return;
    }

    var now = Date.now();
    if (!force && now - this.lastSentAt < this.presenceMinIntervalMs) {
      this.scheduleFlush();
      return;
    }

    this.lastSentAt = now;
    this.pendingCursor = null;

    var payload = { type: "presence" };
    if (this._lastCursor) {
      payload.cursor = this._lastCursor;
    }
    if (this.getViewport) {
      var vp = this.getViewport();
      if (vp && typeof vp.panX === "number") {
        payload.viewport = {
          panX: vp.panX,
          panY: vp.panY,
          scale: vp.scale,
        };
      }
    }
    if (this.laserAltActive && this.pendingLaser) {
      payload.laser = this.pendingLaser;
    }

    this.ws.send(JSON.stringify(payload));
  };

  WbBoardPresence.prototype.notifyViewportChange = function () {
    this.ensureLastClientPoint();
    this.remapCursorFromLastClient();
    this.refreshPeerCursors();
    this.sendPresenceFlush(false);
  };

  /** Если мышь ещё не двигали — считаем курсор в центре доски (тачпад-pan без mousemove). */
  WbBoardPresence.prototype.ensureLastClientPoint = function () {
    if (this._lastClientX != null && this._lastClientY != null) return;
    if (!this.canvas) return;
    var rect = this.canvas.getBoundingClientRect();
    if (rect.width < 8 || rect.height < 8) return;
    this._lastClientX = rect.left + rect.width / 2;
    this._lastClientY = rect.top + rect.height / 2;
  };

  /** После pan без mousemove мировой курсор под экранной точкой меняется — пересчитываем. */
  WbBoardPresence.prototype.remapCursorFromLastClient = function () {
    this.ensureLastClientPoint();
    if (this._lastClientX == null || this._lastClientY == null) return;
    var pt;
    if (this.mapClientToStage) {
      pt = this.mapClientToStage(this._lastClientX, this._lastClientY);
    } else if (this.canvas) {
      var rect = this.canvas.getBoundingClientRect();
      pt = {
        x: this._lastClientX - rect.left,
        y: this._lastClientY - rect.top,
      };
    } else {
      return;
    }
    this._lastCursor = {
      x: cursorStageCoord(pt.x),
      y: cursorStageCoord(pt.y),
    };
    this.pendingCursor = this._lastCursor;
  };

  /** Live pan/zoom: чужие курсоры сразу в экранных coords + свой presence (throttle). */
  WbBoardPresence.prototype.onLiveViewport = function () {
    this.ensureLastClientPoint();
    this.remapCursorFromLastClient();
    // Без этого peer-курсоры «плывут с камерой» до конца pan и прыгают назад.
    this.refreshPeerCursors();
    var now = Date.now();
    var since = now - this.lastSentAt;
    if (since < 16) {
      var self = this;
      if (!this.flushTimer) {
        this.flushTimer = setTimeout(function () {
          self.flushTimer = null;
          self.sendPresenceFlush(true);
        }, Math.max(0, 16 - since));
      }
      return;
    }
    if (this.flushTimer) {
      clearTimeout(this.flushTimer);
      this.flushTimer = null;
    }
    this.sendPresenceFlush(true);
  };

  WbBoardPresence.prototype.sendPresence = function (x, y, force) {
    this._lastCursor = { x: cursorStageCoord(x), y: cursorStageCoord(y) };
    this.pendingCursor = this._lastCursor;
    if (!this.ws || this.ws.readyState !== 1 || !this.myPeerId) {
      return;
    }
    this.sendPresenceFlush(force);
  };

  WbBoardPresence.prototype.scheduleFlush = function () {
    var self = this;
    if (this.flushTimer) return;
    this.flushTimer = setTimeout(function () {
      self.flushTimer = null;
      self.sendPresenceFlush(true);
    }, this.presenceMinIntervalMs);
  };

  WbBoardPresence.prototype.canSendOps = function () {
    return (
      this.canEditOps &&
      this.ws &&
      this.ws.readyState === 1 &&
      Boolean(this.myPeerId)
    );
  };

  /** Эфемерный сигнал комнаты (презентация / голосование). */
  WbBoardPresence.prototype.sendSignal = function (kind, payload) {
    if (this.silent) return false;
    if (!this.ws || this.ws.readyState !== 1 || !this.myPeerId) return false;
    if (typeof kind !== "string" || !kind) return false;
    this.ws.send(
      JSON.stringify({
        type: "signal",
        kind: kind,
        payload: payload && typeof payload === "object" ? payload : {},
      })
    );
    return true;
  };

  WbBoardPresence.prototype.sendOps = function (payload) {
    var self = this;
    if (!this.canSendOps()) {
      return Promise.reject(new Error("WebSocket not ready for ops"));
    }
    var clientOpId =
      payload.clientOpId ||
      "ws-" +
        (typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : String(Date.now()));
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        delete self.pendingOpsAcks[clientOpId];
        reject(new Error("ops_ack timeout"));
      }, self.opsAckTimeoutMs);
      self.pendingOpsAcks[clientOpId] = { resolve: resolve, reject: reject, timer: timer };
      self.ws.send(
        JSON.stringify({
          type: "ops",
          baseRevision: payload.baseRevision,
          ops: payload.ops,
          clientOpId: clientOpId,
        })
      );
    });
  };

  WbBoardPresence.prototype.resolveOpsAck = function (msg) {
    var key = msg.clientOpId;
    if (!key || !this.pendingOpsAcks[key]) return;
    var pending = this.pendingOpsAcks[key];
    delete this.pendingOpsAcks[key];
    clearTimeout(pending.timer);
    if (msg.ok) {
      pending.resolve(msg);
      return;
    }
    var err = new Error(msg.error || "ops failed");
    err.code = msg.error;
    err.currentRevision = msg.currentRevision;
    err.details = msg;
    pending.reject(err);
  };

  WbBoardPresence.prototype.getPeerViewport = function (peerId) {
    var peer = this.peers[peerId];
    return peer && peer.viewport ? peer.viewport : null;
  };

  WbBoardPresence.prototype.getPeerCursor = function (peerId) {
    var peer = this.peers[peerId];
    return peer && peer.lastCursor ? peer.lastCursor : null;
  };

  WbBoardPresence.prototype.setMapClientToStage = function (fn) {
    this.mapClientToStage = typeof fn === "function" ? fn : null;
  };

  WbBoardPresence.prototype.onMouseMove = function (ev) {
    this._lastClientX = ev.clientX;
    this._lastClientY = ev.clientY;
    var rect = this.canvas.getBoundingClientRect();
    var pt;
    if (this.mapClientToStage) {
      pt = this.mapClientToStage(ev.clientX, ev.clientY);
    } else {
      pt = {
        x: cursorStageCoord(ev.clientX - rect.left),
        y: cursorStageCoord(ev.clientY - rect.top),
      };
    }
    if (this.laserAltActive) {
      this.pendingLaser = {
        x: cursorStageCoord(pt.x),
        y: cursorStageCoord(pt.y),
      };
      this.pushLaserTrailPoint(this.localLaserTrail, this.pendingLaser.x, this.pendingLaser.y);
      this.layoutLocalLaser();
    } else {
      this.pendingLaser = null;
    }
    this.sendPresence(pt.x, pt.y, false);
  };

  WbBoardPresence.prototype.isAltKeyEvent = function (ev) {
    return ev.key === "Alt" || ev.code === "AltLeft" || ev.code === "AltRight";
  };

  WbBoardPresence.prototype.isTypingTarget = function (target) {
    if (!target || !target.tagName) return false;
    var tag = String(target.tagName).toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select") return true;
    if (target.isContentEditable) return true;
    return false;
  };

  WbBoardPresence.prototype.onKeyDown = function (ev) {
    if (!this.isAltKeyEvent(ev) || ev.repeat) return;
    if (this.isTypingTarget(ev.target)) return;
    // Во время перетаскивания предметов Alt = сетка, не лазер.
    if (this.selectionDragging) return;
    ev.preventDefault();
    this.setLaserActive(true);
  };

  WbBoardPresence.prototype.onKeyUp = function (ev) {
    if (!this.isAltKeyEvent(ev)) return;
    this.setLaserActive(false);
  };

  WbBoardPresence.prototype.onWindowBlur = function () {
    this.setLaserActive(false);
  };

  WbBoardPresence.prototype.onSelectionDrag = function (ev) {
    var active = Boolean(ev && ev.detail);
    this.selectionDragging = active;
    if (active) {
      this.setLaserActive(false);
    }
  };

  WbBoardPresence.prototype.attach = function () {
    this.ensureLocalLaserEl();
    this.ensureLaserTrailCanvas();
    this.ensureLastClientPoint();
    this.remapCursorFromLastClient();
    this.canvas.addEventListener("mousemove", this._onMouseMove);
    this.canvas.addEventListener("pointermove", this._onMouseMove);
    window.addEventListener("keydown", this._onKeyDown);
    window.addEventListener("keyup", this._onKeyUp);
    window.addEventListener("blur", this._onWindowBlur);
    window.addEventListener("wb:live-viewport", this._onLiveViewport);
    window.addEventListener("wb:selection-drag", this._onSelectionDrag);
    document.addEventListener("visibilitychange", this._onTabVisible);
    window.addEventListener("focus", this._onTabVisible);
    // Сеть вернулась или страницу достали из кэша «назад» — сразу на связь.
    window.addEventListener("online", this._onTabVisible);
    window.addEventListener("pageshow", this._onTabVisible);
    this.connect();
  };

  WbBoardPresence.prototype.destroy = function () {
    this.closedByUser = true;
    this.setLaserActive(false);
    this.setLaserActiveDom(false);
    this.canvas.removeEventListener("mousemove", this._onMouseMove);
    this.canvas.removeEventListener("pointermove", this._onMouseMove);
    window.removeEventListener("keydown", this._onKeyDown);
    window.removeEventListener("keyup", this._onKeyUp);
    window.removeEventListener("blur", this._onWindowBlur);
    window.removeEventListener("wb:live-viewport", this._onLiveViewport);
    window.removeEventListener("wb:selection-drag", this._onSelectionDrag);
    document.removeEventListener("visibilitychange", this._onTabVisible);
    window.removeEventListener("focus", this._onTabVisible);
    window.removeEventListener("online", this._onTabVisible);
    window.removeEventListener("pageshow", this._onTabVisible);
    if (this.connectTimeoutTimer) {
      clearTimeout(this.connectTimeoutTimer);
      this.connectTimeoutTimer = null;
    }
    if (this.localLaserEl && this.localLaserEl.parentNode) {
      this.localLaserEl.parentNode.removeChild(this.localLaserEl);
    }
    this.localLaserEl = null;
    this.stopLaserTrailLoop();
    if (this.laserTrailCanvas && this.laserTrailCanvas.parentNode) {
      this.laserTrailCanvas.parentNode.removeChild(this.laserTrailCanvas);
    }
    this.laserTrailCanvas = null;
    this.laserTrailCtx = null;
    this.localLaserTrail = [];
    this.peerLaserTrails = Object.create(null);
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.staleCheckTimer) {
      clearInterval(this.staleCheckTimer);
      this.staleCheckTimer = null;
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
    if (this.flushTimer) {
      clearTimeout(this.flushTimer);
      this.flushTimer = null;
    }
    for (var opId in this.pendingOpsAcks) {
      if (Object.prototype.hasOwnProperty.call(this.pendingOpsAcks, opId)) {
        clearTimeout(this.pendingOpsAcks[opId].timer);
      }
    }
    this.pendingOpsAcks = Object.create(null);
    this.stopCursorSmoothLoop();
    for (var peerId in this.peers) {
      if (!Object.prototype.hasOwnProperty.call(this.peers, peerId)) continue;
      var p = this.peers[peerId];
      if (p && p.labelQuietTimer) {
        clearTimeout(p.labelQuietTimer);
        p.labelQuietTimer = null;
      }
    }
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    for (var peerId in this.peers) {
      if (Object.prototype.hasOwnProperty.call(this.peers, peerId)) {
        this.removePeer(peerId);
      }
    }
  };

export { WbBoardPresence };
